import { routeCreator as routeCreatorV1 } from '@occc-app/routes/Segment/utils';
import { SegmentsVersion } from '@occc/config';

const SEGMENTS_BASE_URL = '/v2/segments';

export const routeCreator = {
  list: () => SEGMENTS_BASE_URL,
  create: () => `${SEGMENTS_BASE_URL}/create`,
  details: (uuid: string) => `${SEGMENTS_BASE_URL}/${uuid}`,
};

// TODO: This should be merged with segments.factory when cyclic dependencies are resolved
type SegmentsParts = {
  routeCreator: {
    list: () => string;
    details: (id: string) => string;
  };
};

const routeCreatorByVersion: Record<SegmentsVersion, SegmentsParts> = {
  '1': {
    routeCreator: {
      list: routeCreatorV1.base,
      details: routeCreatorV1.details,
    },
  },
  '2': {
    routeCreator: {
      list: routeCreator.list,
      details: routeCreator.details,
    },
  },
};

export const segmentsRouteCreatorFactory = (version: SegmentsVersion) =>
  routeCreatorByVersion[version];
